/**
 * Valida se um email possui formato válido
 * @param email - String contendo o email a ser validado
 * @returns boolean - true se o email é válido, false caso contrário
 */
export const validateEmail = (email: string): boolean => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
};

/**
 * Valida se um telefone brasileiro possui formato válido (fixo ou celular)
 * Aceita formatos com ou sem máscara: (XX) XXXX-XXXX ou (XX) XXXXX-XXXX
 * @param phone - String contendo o telefone a ser validado
 * @returns boolean - true se o telefone é válido, false caso contrário
 */
export const validatePhone = (phone: string): boolean => {
  const digits = phone.replace(/\D/g, "");
  return digits.length >= 10 && digits.length <= 11;
};
